import { render, staticRenderFns } from "./counterpartiesUserTabs.vue?vue&type=template&id=0885b2ee"
import script from "./counterpartiesUserTabs.vue?vue&type=script&lang=js"
export * from "./counterpartiesUserTabs.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesUserTabs.vue?vue&type=style&index=0&id=0885b2ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports